import { animate, animateChild, group, query, stagger, state, style, transition, trigger } from '@angular/animations'

export const SLIDE_TRIGGER = trigger('slide', [
  state('void', style({ height: '0' })),
  state('shown', style({ height: '*' })),
  transition(':enter', [animate('400ms ease-in-out')]),
  transition(':leave', [animate('400ms ease-in-out')]),
])
export const SUB_LIST_TRIGGER = trigger('subList', [
  transition(':enter', [
    style({ height: 0 }),
    group([
      animate('200ms ease-in-out', style({ height: '*' })),
      query('@subListItem', [stagger(100, [animateChild()])]),
    ]),
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),
    animate('200ms ease-in-out', style({ height: 0, opacity: 0 })),
  ]),
])
export const SUB_LIST_ITEM_TRIGGER = trigger('subListItem', [
  transition(':enter', [
    style({ transform: 'translate3d(16px,0,0)', opacity: 0 }),
    animate('300ms ease-out', style({ transform: 'translate3d(0,0,0)', opacity: 1 })),
  ]),
])
